import axios from "axios";
import Swal from "sweetalert2";
import api from "./api_refresh_token";
import { isObject } from "formik";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer


//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const getTiposManutencaoCadastro = (body) =>
  api
    .post(
      `${baseURL}/tipo_manutencao_store`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      //console.log(response);
      Swal.fire({
        icon: "success",
        title: "Tipo de Manutenção cadastrado com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
// buscar os id's
export const getTiposManutencaoById = (id) =>
  api
    .get(
      `${baseURL}/tipos_manutencao/${id}`,

      // url base + rota de busca
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

//put
export const getTipoManutencaoUpdate = (id, body) =>
  api
    .put(
      `${baseURL}/tipo_manutencao_update/${id}`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      Swal.fire({
        icon: "success",
        title: "Registro alterado com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

//delete
export const deleteTipoManutencao = (id) =>
  api
    .delete(
      `${baseURL}/tipo_manutencao_delete/${id}`,
      // url base + rota de busca

      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )

      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
